import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import PaymentListMain from "Components/Common/PaymentMain/PaymentListMain";

const PaymentLog = () => {
  return (
    // <ContainerWrapper>
    <PaymentListMain />
    // </ContainerWrapper>
  );
};

export default PaymentLog;
